import { Box, TablePagination } from '@mui/material'

const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50] as const

interface TableToolbarProps {
  readonly page: number
  readonly rowsPerPage: number
  readonly totalCount: number
  readonly onChangePage: (event: unknown, newPage: number) => void
  readonly onChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  readonly rowsPerPageOptions?: readonly number[]
}

const TableToolbar = ({
  page,
  rowsPerPage,
  totalCount,
  onChangePage,
  onChangeRowsPerPage,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
}: TableToolbarProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: 1,
      borderColor: 'divider',
    }}
  >
    <TablePagination
      component="div"
      count={totalCount}
      page={page}
      onPageChange={onChangePage}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={onChangeRowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions as number[]}
      showFirstButton
      showLastButton
    />
  </Box>
)

export default TableToolbar
